import { render } from "./NcrmBoardWeeklyTrend.vue?vue&type=template&id=132ce96c&scoped=true"
import script from "./NcrmBoardWeeklyTrend.vue?vue&type=script&lang=js"
export * from "./NcrmBoardWeeklyTrend.vue?vue&type=script&lang=js"

import "./NcrmBoardWeeklyTrend.vue?vue&type=style&index=0&id=132ce96c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-132ce96c"]])

export default __exports__